'use client';

import { FC, useCallback, useState } from 'react';
import { RequestServiceChangeDealerProps } from '../types';
import { CatContextualMenu } from '@blocks-react/components/ContextualMenu';
import { CatButton } from '@blocks-react/components/Button';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import { CatIconChevronUp } from '@blocks-react/components/Icons/ChevronUp';
import { CatIconChevronDown } from '@blocks-react/components/Icons/ChevronDown';
import { Conditional } from '../../common';
import styles from '../RequestService.module.scss';
import { capitalizeText } from '../utils';

export const RequestServiceChangeDealer: FC<
  RequestServiceChangeDealerProps
> = ({ dealersList, onChange, label, isMD, iconSize, buttonSize }) => {
  const [isOpen, setIsOpen] = useState(false);

  const chevronDownIcon = useCallback(() => {
    return (
      <CatIconChevronDown slot="after" size={iconSize}></CatIconChevronDown>
    );
  }, [iconSize]);

  const chevronUpIcon = useCallback(() => {
    return <CatIconChevronUp slot="after" size={iconSize}></CatIconChevronUp>;
  }, [iconSize]);

  const menuPosition = isMD ? 'bottom-end' : 'bottom-start';

  return (
    <CatContextualMenu
      position={menuPosition}
      hasScroll
      onBlContextualMenuOpen={() => setIsOpen(!isOpen)}
      onBlContextualMenuClose={() => setIsOpen(!isOpen)}
    >
      <CatButton
        slot="trigger"
        variant="ghost"
        className={styles['no-padding']}
        size={buttonSize}
      >
        {label}
        <Conditional test={isOpen} fallback={chevronDownIcon()}>
          {chevronUpIcon()}
        </Conditional>
      </CatButton>
      <Conditional test={!!dealersList.length}>
        <div className={styles['change-dealer-height']}>
          <CatList>
            {dealersList.map((item) => (
              <CatListItem key={item.value} onBlSelect={() => onChange(item)}>
                {capitalizeText(item.label)}
              </CatListItem>
            ))}
          </CatList>
        </div>
      </Conditional>
    </CatContextualMenu>
  );
};
